import {Grid, useAddNotification} from '@logistics-frontend/blocks'
import {FrameMessageError, useCardBoundRef} from '@logistics-frontend/hooks'
import React from 'react'

import {useConfigContext} from '../../shared/ui'
import * as classes from './TrustFrame.classes'

type Props = {
  onClose?(): void
  onSuccess?(): void
  bindingUrl: string
  isMobile?: boolean
}

export function TrustFrame(props: Props): React.ReactElement<Props> {
  const {onClose, onSuccess, bindingUrl, isMobile} = props
  const {lang, currency} = useConfigContext()
  const addNotification = useAddNotification()

  function errorHandler(m: FrameMessageError) {
    onClose?.()
    addNotification(m.reason, {type: 'error'})
  }

  const ref = useCardBoundRef<HTMLDivElement>(bindingUrl, {
    currency,
    lang,
    device: isMobile ? 'mobile' : 'desktop',
    className: classes.iframe,
    onSuccess: onSuccess,
    onError: errorHandler,
    onAbort: onClose,
  })

  return <Grid ref={ref} justify="center" container />
}
